import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import StructuredEmailEditor from '../../components/email-templates/StructuredEmailEditor';

const EmailTemplates: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <button
            onClick={() => navigate('/settings')}
            className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('settings.emailTemplates.backToSettings')}
          </button>
          <h1 className="text-3xl font-bold text-gray-900 mb-1">{t('settings.emailTemplates.pageHeading')}</h1>
          <p className="text-gray-600">{t('settings.emailTemplates.pageIntro')}</p>
        </div>

        <div className="bg-white rounded-xl shadow-md p-6">
          <StructuredEmailEditor />
        </div>
      </div>
    </div>
  );
};

export default EmailTemplates;
